import React, { useState } from "react";

import CardSkeleton from "src/organization/pages/project/environment/metrics/components/CardSkeleton";
import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import useInitialTimeframe from "src/organization/pages/project/environment/metrics/hooks/useInitialTimeframe";
import { MetricsContext } from "src/organization/pages/project/environment/metrics/hooks/useMetricsContext";
import NoData from "src/organization/pages/project/environment/metrics/http/components/nodata";
import { PageTimeFrameType } from "src/organization/pages/project/environment/metrics/http/types";
import { defaultPollTime } from "src/organization/pages/project/environment/metrics/resources/settings";
import { parseTimeDuration } from "src/organization/pages/project/environment/metrics/utils/parseDimensions/parseDimensions";
import useServerCachesMetricsPoll from "src/organization/pages/project/environment/observabilitySandbox/hooks/useServerCachesMetricsPoll";

import { ServerCachesMetricsContext } from "./context";
import ServerCachesOverviewChart from "./ServerCachesOverviewChart";
import * as S from "./style";
import { formatDataForPsh } from "./utils";

const ServerCachesOverview = () => {
  const initialTimeframe = useInitialTimeframe();
  const [timeFrame, setTimeFrame] =
    useState<PageTimeFrameType>(initialTimeframe);

  const pollInterval = parseTimeDuration(
    initialTimeframe.poll || defaultPollTime[timeFrame.id || "fallback"]
  );

  const { data, status, lastUpdated } = useServerCachesMetricsPoll({
    timeFrame
  });

  const cacheData = data?.data;

  const PSHdata = formatDataForPsh(cacheData);

  return (
    <MetricsContext.Provider
      value={{ timeFrame, isDeployment: false, setTimeFrame }}
    >
      <ServerCachesMetricsContext.Provider
        value={{
          timeframe: timeFrame
        }}
      >
        <S.CachesContainer>
          <TimeframeControl
            isUpdating={status.isLoading}
            pollInterval={pollInterval}
            lastUpdated={lastUpdated}
            timeframe={{
              timeframe: timeFrame,
              onChange: setTimeFrame
            }}
          />
          <S.CachesWrapper id="server-caches-overview-wrapper">
            {status.refresh && <CardSkeleton />}
            {PSHdata ? (
              <ServerCachesOverviewChart cachesData={PSHdata} />
            ) : (
              <NoData />
            )}
          </S.CachesWrapper>
        </S.CachesContainer>
      </ServerCachesMetricsContext.Provider>
    </MetricsContext.Provider>
  );
};

export default ServerCachesOverview;
